export default {
	emailHostList: '/iglobalwin-mail-api/admin/mail/host/config/list', // 邮箱host配置列表
	emailHostAdd: '/iglobalwin-mail-api/admin/mail/host/config', // 邮箱host配置新增
	emailHostDel: '/iglobalwin-mail-api/admin/mail/host/config/{id}', // 邮箱host配置删除
	emailHostEdit: '/iglobalwin-mail-api/admin/mail/host/config/{id}', // 邮箱host配置修改
};
